import config from './config';
import Permission from './permission';
import SiteAuth from './siteAuth';

export default new SiteAuth(config);

export { Permission };
